import { createLogger } from "@/src/lib/logging/logger";
import { isPriorAuthorizationCompleteForReferralAuth } from "@/src/lib/prior-authorization/referral-auth-completeness";
import { PriorAuthorization } from "@/src/models/documents/prior-authorization/prior-authorization";

const logger = createLogger({ fileName: "referral-auth-prior-authorization-selection" });

function sortByNewest(priorAuthorizations: PriorAuthorization[]): PriorAuthorization[] {
  return [...priorAuthorizations].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
}

export function selectReferralAuthTrackingPriorAuthorization(
  linkedPriorAuthorizations: PriorAuthorization[],
  taskPriorAuthorization?: PriorAuthorization | null
): PriorAuthorization | null {
  const candidates = taskPriorAuthorization
    ? [
        taskPriorAuthorization,
        ...linkedPriorAuthorizations.filter((authorization) => authorization.id !== taskPriorAuthorization.id),
      ]
    : linkedPriorAuthorizations;
  const complete = sortByNewest(candidates.filter((pa) => isPriorAuthorizationCompleteForReferralAuth(pa)));

  if (complete.length > 0) {
    return complete[0];
  }

  const open = sortByNewest(candidates.filter((pa) => !isPriorAuthorizationCompleteForReferralAuth(pa)));

  if (open.length > 1) {
    logger.warn("Multiple incomplete prior authorizations linked; using newest for referral auth", {
      priorAuthorizationIds: open.map((pa) => pa.id),
      selectedPriorAuthorizationId: open[0].id,
    });
  }

  return open[0] ?? null;
}
